<script setup>
  defineOptions({
    name: "ComponentCategoryBadge",
  });

  defineProps({
    label: {
      type: [String, Number],
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <span
    class="inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium"
    :class="{
      // nested within a 'button' or an 'a', we change the bg color on hover
      'bg-orange-100 text-orange-600 in-[a]:hover:bg-orange-200 in-[button]:hover:bg-orange-200':
        color === 'yellow' || color === 'orange' || color === 'warning',
      'bg-mcred-100 text-mcred-600 in-[a]:hover:bg-mcred-200 in-[button]:hover:bg-mcred-200':
        color === 'red' || color === 'error',
      'bg-mcblue-100 text-mcblue-600 in-[a]:hover:bg-mcblue-200 in-[button]:hover:bg-mcblue-200':
        color === 'blue' || color === 'info',
      'bg-mcgreen-100 text-mcgreen-600 in-[a]:hover:bg-mcgreen-200 in-[button]:hover:bg-mcgreen-200':
        color === 'green' || color === 'success',
      'bg-gray-100 text-gray-600 in-[a]:hover:bg-gray-200 in-[button]:hover:bg-gray-200':
        color === 'gray' || color === null,
    }"
    :data-test="getTestId('category-badge')"
  >
    {{ label }}
    <slot />
  </span>
</template>
